module.exports = __webpack_public_path__ + "static/media/smHome3.27593b14.jpg";